import cls from "@fvilers/cls";
import { ComponentPropsWithRef } from "react";
import styles from "./Badge.module.css";

type BadgeProps = {
  color?: "neutral" | "primary";
  size?: "md" | "sm";
  variant?: "contained" | "outline";
} & ComponentPropsWithRef<"span">;

export function Badge({
  children,
  className,
  color = "primary",
  size = "md",
  variant = "contained",
  ...props
}: BadgeProps) {
  return (
    <span
      className={cls(
        styles.Badge,
        styles[variant],
        styles[`size-${size}`],
        styles[`color-${color}`],
        className,
      )}
      data-slot="badge"
      {...props}
    >
      {children}
    </span>
  );
}
